import React, { useEffect, useState } from "react";
import AppShell from "../../components/AppShell";
import { ADMIN_NAV } from "./_nav";
import { api, errFrom } from "../../lib/api";
import { Button } from "../../components/ui/button";
import { Input } from "../../components/ui/input";
import { Label } from "../../components/ui/label";
import { Dialog, DialogContent, DialogHeader, DialogTitle, DialogTrigger, DialogFooter } from "../../components/ui/dialog";
import { toast } from "sonner";
import { Plus, Building2, Trash2 } from "lucide-react";

export default function AdminDealerships() {
  const [list, setList] = useState([]);
  const [open, setOpen] = useState(false);
  const [name, setName] = useState("");
  const [address, setAddress] = useState("");

  async function load() {
    try { const { data } = await api.get("/dealerships"); setList(data); }
    catch (e) { toast.error(errFrom(e)); }
  }
  useEffect(() => { load(); }, []);

  async function add() {
    if (!name.trim()) return toast.error("Name required");
    try {
      await api.post("/admin/dealerships", { name, address });
      toast.success("Dealership added"); setOpen(false); setName(""); setAddress(""); load();
    } catch (e) { toast.error(errFrom(e)); }
  }

  async function del(id) {
    try { await api.delete(`/admin/dealerships/${id}`); toast.success("Removed"); load(); }
    catch (e) { toast.error(errFrom(e)); }
  }

  return (
    <AppShell nav={ADMIN_NAV} title="Dealerships" subtitle="Partners">
      <div className="flex justify-end mb-5">
        <Dialog open={open} onOpenChange={setOpen}>
          <DialogTrigger asChild>
            <Button className="bg-[#FF3B30] hover:bg-[#E02920] h-11 px-5" data-testid="add-dealership-button"><Plus size={16} className="mr-2" />Add dealership</Button>
          </DialogTrigger>
          <DialogContent className="bg-[#141414] border-white/10 text-white">
            <DialogHeader><DialogTitle className="font-heading">New dealership</DialogTitle></DialogHeader>
            <div className="space-y-4 py-2">
              <div><Label className="text-overline">Name</Label><Input value={name} onChange={(e) => setName(e.target.value)} className="mt-2 bg-[#0A0A0A] border-white/10 h-11" data-testid="add-dealership-name" /></div>
              <div><Label className="text-overline">Address (optional)</Label><Input value={address} onChange={(e) => setAddress(e.target.value)} className="mt-2 bg-[#0A0A0A] border-white/10 h-11" data-testid="add-dealership-address" /></div>
            </div>
            <DialogFooter><Button onClick={add} className="bg-[#FF3B30] hover:bg-[#E02920]" data-testid="add-dealership-submit">Create</Button></DialogFooter>
          </DialogContent>
        </Dialog>
      </div>
      <div className="grid sm:grid-cols-2 lg:grid-cols-3 gap-4">
        {list.map((d) => (
          <div key={d.id} className="brand-surface rounded-2xl p-5 hover-lift flex items-start justify-between" data-testid={`dealership-card-${d.id}`}>
            <div className="flex items-start gap-3">
              <div className="w-10 h-10 rounded-lg bg-[#FF3B30]/15 text-[#FF3B30] flex items-center justify-center"><Building2 size={18} /></div>
              <div>
                <div className="font-heading font-semibold">{d.name}</div>
                <div className="text-xs text-zinc-500 mt-0.5">{d.address || "No address"}</div>
              </div>
            </div>
            <button onClick={() => del(d.id)} className="text-zinc-500 hover:text-red-400 p-2" data-testid={`delete-dealership-${d.id}`}><Trash2 size={16} /></button>
          </div>
        ))}
        {list.length === 0 && <div className="col-span-full text-center text-zinc-500 py-12">No dealerships yet.</div>}
      </div>
    </AppShell>
  );
}
